import { useState } from 'react'
import './AboutUs.css'
import LandingNav from '../common/LandingNav/LandingNav'
import ContactForm from './DemoContact/ContactForm'
import './DemoContact/ContactForm.css'

export default function AboutUs() {
  const [isDemoOpen, setIsDemoOpen] = useState(false)

  return (
    

    <div className="about-container">
<LandingNav />
     

      <section className="hero-section">
        <div className="hero-content">
          <span className="badge">Our Story</span>
          <h1 className="hero-title">
            Building the Future of <span className="highlight">Intelligent AI</span> Interactions
          </h1>
          <p className="hero-description">
            At Consilient Labs, we're pioneering a new era of artificial intelligence that understands context, 
            collaborates seamlessly, and delivers unprecedented accuracy. Our mission is to transform how 
            organizations leverage AI through advanced contextual memory and multi-agent systems.
          </p>
            <div className="hero-buttons">
              <a href="https://consilientlabs.io/" className="btn-primary">
                Learn More
               </a>
            <button className="btn-secondary" onClick={() => setIsDemoOpen(true)}>
              <span></span> Contact the Team
            </button>
            <ContactForm isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />
          </div>
        </div>

        <div className="info-card">
          <div className="card-header">
            <div className="window-dots">
              <div className="dot dot-red"></div>
              <div className="dot dot-yellow"></div>
              <div className="dot dot-green"></div>
            </div>
            <div className="card-title">Consilient Labs</div>
          </div>

          <div className="info-section">
            <div className="info-label">Mission</div>
            <div className="info-text">
              Empowering organizations with cutting-edge AI solutions that unify knowledge across disciplines,
              enabling smarter decisions and breakthrough insights.
            </div>
          </div>

          <div className="info-section">
            <div className="info-label">Vision</div>
            <div className="info-text">
              To create the most advanced AI platform that seamlessly integrates contextual 
              awareness, multi-agent collaboration, and cross-LLM capabilities.
            </div>
          </div>

          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-value"></div>
              <div className="stat-label">Advanced AI algorithms for pattern recognition</div>
            </div>
            <div className="stat-item">
              <div className="stat-value"></div>
              <div className="stat-label">Cross-disciplinary knowledge integration</div>
            </div>
            <div className="stat-item">
              <div className="stat-value"></div>
              <div className="stat-label">Real-time data analysis and insights</div>
            </div>
            <div className="stat-item">
              <div className="stat-value"></div>
              <div className="stat-label">Scalable enterprise solutions</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    
  );
}


